/// <amd-module name="SuiteCommerce.FeaturedCategory.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.FeaturedCategory.View", ["require", "exports", "jQuery", "CustomContentType.Base.View", "Backbone.CollectionView", "SuiteCommerce.FeaturedCategory.Model", "SuiteCommerce.FeaturedCategory.Button.View", "SuiteCommerce.FeaturedCategory.Button.Model", "SuiteCommerce.FeaturedCategory.Instrumentation", "sc_featuredcategory_cct.tpl", "SuiteCommerce.FeaturedCategory.Item.View"], function (require, exports, jQuery, CustomContentTypeBaseView, BackboneCollectionView, FeaturedCategory_Model_1, FeaturedCategory_Button_View_1, FeaturedCategory_Button_Model_1, Instrumentation_1, featuredCategoryTemplate, Item_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FeaturedCategoryView = void 0;
    var FeaturedCategoryView = /** @class */ (function (_super) {
        __extends(FeaturedCategoryView, _super);
        function FeaturedCategoryView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = featuredCategoryTemplate;
            _this.container = options.container;
            _this.buttonView = new FeaturedCategory_Button_View_1.ButtonView({ model: new FeaturedCategory_Button_Model_1.ButtonModel() });
            _this.model = new FeaturedCategory_Model_1.FeaturedCategoryModel({ container: _this.container });
            _this.setupListeners();
            return _this;
        }
        FeaturedCategoryView.prototype.setupListeners = function () {
            var _this = this;
            this.model.on('reset sync add remove change destroy', function () {
                _this.updateCategoryButtonSettings();
                _this.render();
            });
            this.model.items.on('reset sync add remove change destroy', function () { return _this.render(); });
        };
        FeaturedCategoryView.prototype.install = function (settings, contextData) {
            _super.prototype.install.call(this, settings, contextData);
            this.parseSettings(settings);
            this.fetchFeaturedCategoryData();
            return jQuery.Deferred().resolve();
        };
        FeaturedCategoryView.prototype.update = function (settings) {
            _super.prototype.update.call(this, settings);
            this.parseSettings(settings);
            this.clearItems();
            this.fetchFeaturedCategoryData();
            return jQuery.Deferred().resolve();
        };
        FeaturedCategoryView.prototype.parseSettings = function (settings) {
            this.model.addProperties(settings);
        };
        FeaturedCategoryView.prototype.fetchFeaturedCategoryData = function () {
            if (this.model.categoryId) {
                this.fetchItemCollection();
                this.fetchFeaturedCategoryModel();
            }
        };
        FeaturedCategoryView.prototype.fetchItemCollection = function () {
            this.model.items.setURLForSearchApi({
                limit: this.model.numberOfItems,
                sortingField: this.model.itemSorting,
                commerceCategoryId: this.model.categoryId
            });
            var fetchItemInformationLog = Instrumentation_1.default.getLog('fetchItemInformationLog');
            fetchItemInformationLog.startTimer();
            this.model.items.fetch().done(function () {
                fetchItemInformationLog.endTimer();
                fetchItemInformationLog.setParameters({
                    activity: 'Time it takes to fetch the item data',
                    totalTime: fetchItemInformationLog.getElapsedTimeForTimer(),
                });
                fetchItemInformationLog.submit();
            });
        };
        FeaturedCategoryView.prototype.fetchFeaturedCategoryModel = function () {
            if (this.model.buttonText) {
                var fetchCommerceCategoryDataLog_1 = Instrumentation_1.default.getLog('fetchCommerceCategoryDataLog');
                fetchCommerceCategoryDataLog_1.startTimer();
                this.model.fetch().done(function () {
                    fetchCommerceCategoryDataLog_1.endTimer();
                    fetchCommerceCategoryDataLog_1.setParameters({
                        activity: 'Time it takes to fetch the Category data',
                        totalTime: fetchCommerceCategoryDataLog_1.getElapsedTimeForTimer(),
                    });
                    fetchCommerceCategoryDataLog_1.submit();
                });
            }
        };
        FeaturedCategoryView.prototype.updateCategoryButtonSettings = function () {
            this.buttonView.model.updateButtonSettings({
                buttonText: this.model.buttonText,
                customUrl: this.model.customUrl,
                fullurl: this.model.fullUrl,
                buttonStyle: this.model.buttonStyle
            });
        };
        FeaturedCategoryView.prototype.validateContextDataRequest = function () {
            return true;
        };
        FeaturedCategoryView.prototype.logGoToCategory = function () {
            var categoryButtonUsageLog = Instrumentation_1.default.getLog('categoryButtonUsage');
            categoryButtonUsageLog.setParameters({
                activity: 'Redirect to category button click',
            });
            categoryButtonUsageLog.submit();
        };
        FeaturedCategoryView.prototype.clearItems = function () {
            this.model.items.reset();
        };
        Object.defineProperty(FeaturedCategoryView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'FeaturedCategory.Items.View': function () {
                        return new BackboneCollectionView({
                            childView: Item_View_1.ItemView,
                            collection: _this.model.items,
                            childViewOptions: {
                                colsPerRow: _this.model.colsPerRow,
                                colsPerRowPhone: _this.model.colsPerRowPhone,
                                showItemName: _this.model.showItemName,
                                showItemPrice: _this.model.showItemPrice,
                            },
                        });
                    },
                    'FeaturedCategory.Button.View': function () {
                        return _this.buttonView;
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        FeaturedCategoryView.prototype.getContext = function () {
            if (!this.model.customUrl) {
                this.model.customUrl = this.model.fullUrl;
            }
            return {
                customUrl: this.model.customUrl,
                hasHeader: this.model.hasHeader,
                hasItems: this.model.items.size() > 0,
                headerAllowLink: this.model.headerAllowLink,
                headerIsHtml: this.model.headerIsHtml,
                headerPosition: this.model.headerPosition,
                headerText: this.model.headerText
            };
        };
        return FeaturedCategoryView;
    }(CustomContentTypeBaseView));
    exports.FeaturedCategoryView = FeaturedCategoryView;
});
